import React from 'react';
import '../styles/Footer.css';
import spotifyIcon from '../assets/spotify-logo.png';
import appleIcon from '../assets/apple-podcast-icon.svg';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} That's A Dumb Rule? Podcast</p>
      <div className="footer-icons">
        <a href="https://podcasts.apple.com/" target="_blank" rel="noopener noreferrer">
          <img src={appleIcon} alt="Apple Podcasts" className="footer-icon" />
        </a>
        <a href="https://open.spotify.com/" target="_blank" rel="noopener noreferrer">
          <img src={spotifyIcon} alt="Spotify" className="footer-icon" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;